// extracted by mini-css-extract-plugin
export default {"App":"App_App__tArHs","App-logo":"App_App-logo__e+hDW","App-logo-spin":"App_App-logo-spin__yvW4b","App-header":"App_App-header__gE7ga","App-link":"App_App-link__rBtR5"};